import { render, staticRenderFns } from "./PaymentsComponent.vue?vue&type=template&id=5e287385"
import script from "./PaymentsComponent.vue?vue&type=script&lang=js"
export * from "./PaymentsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports